import { loadSelf } from "@fdn/profile_store";
import cookie from "cookie";
import Cookies from "js-cookie";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import {
	Fetching, getToday, AdsDetik, checkImageViews, setDataLayer, checkDevice,
} from "Helpers/utils";
import checkSelfCookie from "Helpers/checkSelfCookie";
import { END } from "redux-saga";
import dynamic from "next/dynamic";
import vars from "Consts/vars";
import {
	// getComments,submitComment,
	submitFollow, submitLike,
} from "Helpers/fetch";
import { loadReview } from "Store/Review/lib/actions";
// import { loadCategory } from "Store/ProductCategory/lib/actions";
import { wrapper } from "Store/index";
import { loadHighlightReview } from "Store/HightlightReview/lib/actions";
import { loadProductMatches } from "Store/ProductMatches/lib/actions";
import { loadBrandList } from "Store/BrandList/lib/actions";
import { loadTopMembers } from "Store/TopMembers/lib/actions";
import useElementOnScreen from "Lib/useElementOnScreen";
import Env from "Consts/env";

const Layout = dynamic(() => import("Containers/layout"), {
	ssr: true,
});

const Banner = dynamic(() => import("Components/banner/banner"), {
	ssr: false,
});

const InfoFooter = dynamic(() => import("Containers/info_footer/infoFooter"), {
	ssr: false,
});
const MetaHead = dynamic(() => import("Containers/meta_head"), {
	ssr: true,
});
const ModalReport = dynamic(() => import("Components/modal_report/modalReport"), {
	ssr: false,
});
const ErrTopMember = dynamic(() => import("Components/error/top_member"), {
	ssr: false,
});
const ErrProductMatches = dynamic(() => import("Components/error/product_matches"), {
	ssr: false,
});
const FakeFree = dynamic(() => import("Components/banner_fake_free"), {
	ssr: true,
});

const SkeletonTopMember = dynamic(() => import("Components/skeleton/top_member/topMember"));
const SkeletonProductMatches = dynamic(() => import("Components/skeleton/product_matches/productMatchesSkeleton"));

const NewestReview = dynamic(() => import("Containers/newest_review/newestReview"), {
	ssr: true,
});

const HighlightReview = dynamic(() => import("Components/highlight_review/highlightReview"), {
	ssr: true,
});

const ProductMatches = dynamic(() => import("Containers/product_matches/productMatches"), {
	ssr: false,
});

const ImageReviews = dynamic(() => import("Components/modal/image_reviews"), {
	ssr: false,
});

const TopMember = dynamic(() => import("Containers/top_member/topMember"), {
	ssr: true,
});

const btoa = require("btoa");

const Index = (props) => {

	const prop = props;

	const dispatch = useDispatch();
	const storeData = useSelector((state) => state);

	// banner Top view screen
	const [bannerFlags, setBannerFlags] = useState({
		FDBR_home_web_top: false,
		FDBR_home_web_bottom: false,
	});

	const [refBannerTop, isVisibleBannerTop] = useElementOnScreen({
		root: null,
		rootMargin: "0px",
		threshold: 1.0,
	});

	const [refBannerBottom, isVisibleBannerBottom] = useElementOnScreen({
		root: null,
		rootMargin: "0px",
		threshold: 1.0,
	});

	const [tempReview, setTempReview] = useState({
		newsReview: {
			data: props.getNewestReviewData?.data,
			current: 0,
			next_id: 0,
			total: 0,
			on_load: false,
		},
		highlightReview: props.getHighlightReview,
	});
	const [topMembers, setTopMembers] = useState([]);
	const [DataBanner, setDataBanner] = useState([]);

	const [IDReport, setIDReport] = useState(0);
	const [IsModalReport, setIsModalReport] = useState(false);
	// const [isLoadingHighlight, setIsLoadingHighlight] = useState(false);

	const [imagePopup, setImagePopup] = useState({ isOpen: false, imgs: [], currImg: 0 });

	const [tabChoose, setTabChoose] = useState("newest");
	// const [tabList, setTabList] = useState([]);

	// const loadComments = (params) => {

	// 	const tempUpdateReview = [...tempReview.newsReview.data];
	// 	const tempIdx = tempUpdateReview.findIndex((review) => review.id === params.id);
	// 	const tempData = tempReview.newsReview.data[tempIdx];
	// 	const data = {
	// 		type: "review",
	// 		limit: 5,
	// 		postid: params.id,
	// 		nextid: JSON.stringify(tempData.comments.pagination
	// 			? tempData.comments.pagination.next_id : 0),
	// 		authorization: Cookies.get("token"),
	// 	};

	// 	getComments(data).then((res) => {

	// 		if (res.data.meta.code === 200) {

	// 			if (tempData.comments.data.length === 0) {

	// 				tempData.comments = {
	// 					data: [...res.data.data],
	// 					pagination: res.data.pagination,
	// 				};

	// 			} else {

	// 				tempData.comments = {
	// 					data: tempData.comments.data.concat([...res.data.data]),
	// 					pagination: res.data.pagination,
	// 				};

	// 			}

	// 			tempData.is_more_comments = true;
	// 			tempUpdateReview[tempIdx] = tempData;

	// 			setTempReview((datalist) => ({
	// 				...datalist,
	// 				newsReview: {
	// 					...datalist.newsReview,
	// 					data: tempUpdateReview,
	// 				},
	// 			}));

	// 		} else {

	// 			tempData.is_more_comments = false;
	// 			setTempReview((datalist) => ({
	// 				...datalist,
	// 				newsReview: {
	// 					...datalist.newsReview,
	// 					data: tempUpdateReview,
	// 				},
	// 			}));

	// 		}

	// 	});

	// };

	const resetDataReviews = () => {
		setTempReview((data) => ({
			...data,
			newsReview: {
				data: [],
				current: 0,
				next_id: 0,
				total: 0,
				on_load: false,
			},
		}));
	};

	const handleReloadData = ({
		page = 1, limit = 5, next_id = "", type_review = "",
	}) => {

		dispatch(loadReview({
			Authorization: Cookies.get("token") || "",
			page,
			limit,
			next_id,
			type_review,
		}));

	};

	const handleExpandText = (id) => {

		const tempIdx = tempReview.newsReview.data.findIndex(
			(item) => item.id === id,
		);
		const tempDataReview = tempReview.newsReview.data[tempIdx];

		tempDataReview.is_expand = true;

		setTempReview((dataList) => ({
			...dataList,
			newsReview: {
				...dataList.newsReview,
				data: dataList.newsReview.data,
			},
		}));

	};

	const handleExpandTextHighlight = (id) => {

		const tempIdx = tempReview.highlightReview.findIndex(
			(item) => item.rvwr_id === id,
		);
		const tempDataHighlight = tempReview.highlightReview[tempIdx];

		tempDataHighlight.is_expand = true;

		setTempReview((listData) => ({
			...listData, highlightReview: listData.highlightReview,
		}));

	};

	const handleSubmitReport = (e) => {

		e.preventDefault();
		const formData = new FormData(e.target);
		const formProps = Object.fromEntries(formData);

		const data = {
			rvwr_id: IDReport,
			type: formProps.type,
			desc: formProps.desc,
		};

		Fetching({
			method: "POST",
			url: "submitReport",
			data: {
				Authorization: Cookies.get("token"),
				data,
			},
		})
			.then((res) => {

				if (res.data.meta.code === 200) {

					setIsModalReport(false);
					alert(`${res.data.meta.msg}`);

				} else {

					alert(`${res.data.meta.msg}`);

				}

			})
			.catch((err) => {

				alert(`Error get data: ${err}`);

			});

	};

	const handleOpenReport = (params) => {

		setIDReport(params.id);

		setIsModalReport(true);

	};

	const handleLogIn = () => {

		const pageReferrer = window ? window.location.href : process.env.NEXT_PUBLIC_REVIEWS_DOMAIN;
		window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}?url=${pageReferrer}`;

	};

	const handleLike = (params = {}) => {

		const tempIdx = tempReview.newsReview.data.findIndex(
			(item) => item.id === params.id,
		);
		const tempDataReview = tempReview.newsReview.data[tempIdx];

		if (!tempDataReview.is_like || typeof tempDataReview?.total_likes !== "number" || tempDataReview?.total_likes === 0 || tempDataReview?.total_likes === "0") {

			tempDataReview.is_like = !tempDataReview.is_like;
			tempDataReview.total_likes = parseInt(tempDataReview?.total_likes || 0, 10) + 1;

		} else {

			tempDataReview.is_like = false;
			tempDataReview.total_likes = parseInt(tempDataReview?.total_likes || 0, 10) - 1;

		}

		submitLike({
			data: {
				is_liked: tempDataReview.is_like,
				id: params.id,
			},
			Authorization: Cookies.get("token"),
			id: params.id,
		}).then((res) => {

			if (res.data.meta.code === 200) {

				setTempReview((data) => ({
					...data,
					newsReview: {
						...data.newsReview,
						data: data.newsReview.data,
					},
				}));

			}

		});

	};

	const handleToggleComment = (params) => {

		const tempUpdateReview = [...tempReview.newsReview.data];
		const tempIdx = tempUpdateReview.findIndex((review) => review.id === params.id);
		const tempData = tempReview.newsReview.data[tempIdx];

		if (!tempData.show_comment) {

			tempData.show_comment = true;
			tempUpdateReview[tempIdx] = tempData;

		} else {

			tempData.show_comment = false;
			tempUpdateReview[tempIdx] = tempData;

		}

		setTempReview((dataList) => ({
			...dataList,
			newsReview: {
				...dataList.newsReview,
				data: tempUpdateReview,
			},
		}));

		// loadComments(params);

	};

	const handleBanner = (placement) => {

		Fetching({
			method: "POST",
			url: "getBanner",
			data: {
				placement,
			},
		})
			.then((res) => {

				if (res.data.meta.code === 200) {

					setDataBanner((data) => [...data, ...res.data.data]);

				} else {

					console.log(`${res.data.meta.msg}`);

				}

			})
			.catch((err) => {

				console.log(`Error get data: ${err}`);

			});

	};

	// const handleTablist = () => {

	// 	Fetching({
	// 		method: "GET",
	// 		url: "getTabList",
	// 	})
	// 		.then((res) => {

	// 			if (res.data.meta.code === 200) {

	// 				setTabList(res.data.data);
	// 				setTabChoose(() => res.data.data[0].type);

	// 				handleReloadData({
	// 					page: 1,
	// 					limit: 5,
	// 					next_id: "",
	// 					type_review: res.data.data[0].type || "newest",
	// 				});

	// 			} else {

	// 				setTabList(vars.Tabs_news);

	// 				handleReloadData({
	// 					page: 1,
	// 					limit: 5,
	// 					next_id: "",
	// 					type_review: "newest",
	// 				});

	// 			}

	// 		})
	// 		.catch(() => {

	// 			setTabList(vars.Tabs_news);

	// 			handleReloadData({
	// 				page: 1,
	// 				limit: 5,
	// 				next_id: "",
	// 				type_review: "newest",
	// 			});

	// 		});

	// };

	const handleInput = (e, params = {}) => {

		const tempUpdateReview = [...tempReview.newsReview.data];
		const tempIdx = tempUpdateReview.findIndex((review) => review.id === params.id);
		const tempData = tempUpdateReview[tempIdx];

		tempData.comment = e.target.value;
		tempUpdateReview[tempIdx] = tempData;

		setTempReview((data) => ({
			...data,
			newsReview: {
				...data.newsReview,
				data: tempUpdateReview,
			},
		}));

	};

	const handleComment = (e, params = {}) => {

		e.preventDefault();

		document.getElementById(`comment-button-${params.id}`).classList.add("disabled");
		const comment = {
			type: "review",
			object_id: params.id,
			user_id: params.self_id,
			text: document.getElementById(`comment-form-${params.id}`).elements[0].value,
			parent_id: 0,
		};

		const tempUpdateReview = [...tempReview.newsReview.data];
		const tempIdx = tempUpdateReview.findIndex((review) => review.id === params.id);
		const tempData = tempUpdateReview[tempIdx];
		const commentTotal = document.getElementById(`comment-count-${params.id}`).textContent;
		const commentData = {
			created_at: getToday(),
			text: comment.text,
			user: {
				username: storeData.storeSelf.data.username,
				picture: storeData.storeSelf.data.picture ? storeData.storeSelf.data.picture.large : "",
				is_verified: storeData.storeSelf.data.is_verified,
			},
		};

		if (comment.text.trim().length === 0) {

			document.getElementById(`comment-button-${params.id}`).classList.add("disabled");
			document.getElementById(`comment-form-${params.id}`).elements[0].value = "";

		} else {

			tempData.comments.data.unshift(commentData);

			setTempReview((data) => ({
				...data,
				newsReview: {
					...data.newsReview,
					data: tempUpdateReview,
				},
			}));

			document.getElementById(`comment-count-${params.id}`).innerHTML = `<i class="icon-ic_comment"></i>${+commentTotal + 1}`;
			document.getElementById(`comment-form-${params.id}`).elements[0].value = "";

			// submitComment({
			// 	data: comment,
			// 	Authorization: Cookies.get("token"),
			// }).then((res) => {

			// 	console.log(res.data);

			// }).catch((err) => {

			// 	console.log(err);

			// });

		}

	};

	const handleGoToEditReview = ({ id, slug }) => {

		if (storeData.storeSelf.data.id) {

			const encoded = btoa(id.toString());
			window.location.href = `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/review/product/edit/${encoded}?slug=${slug}&referer=${window.location.href}`;

		} else {

			window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}/?url_referrer=${process.env.NEXT_PUBLIC_ROOT_DOMAIN}`;

		}

	};

	const handleAddReview = ({ slug, referer }) => {

		if (storeData.storeSelf.data.id) {

			window.location.href = `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/review/product/add?slug=${slug}&referer=${referer}`;

		} else {

			const pageReferrer = window ? window.location.href : `${process.env.NEXT_PUBLIC_REVIEWS_DOMAIN}/add-review`;

			window.location.href = `${process.env.NEXT_PUBLIC_SSO_DOMAIN}?url=${pageReferrer}`;

		}

	};

	const handleImageView = (index, imgs) => {

		setImagePopup({
			currImg: index,
			imgs: imgs.map((data) => ({
				src: checkImageViews(data.img_url), id: data.rvwr_image_id, alt: data.img_alt,
			})),
			isOpen: true,
		});

	};

	const handleChangeTabs = (activeTab) => {

		setTabChoose(() => activeTab);
		resetDataReviews();
		handleReloadData({
			page: 1,
			limit: 5,
			next_id: "",
			type_review: activeTab,
		});
		setTempReview((data) => ({
			...data,
			newsReview: {
				...data.newsReview,
				current: 0,
			},
		}));

	};

	const handleLoadMore = () => {

		const page = tempReview.newsReview.current + 1;

		if (["newest", "fd-babes", "try-and-review"].includes(tabChoose)) {

			handleReloadData(
				{
					// page: 1,
					limit: 5,
					next_id: tempReview.newsReview.next_id,
					type_review: tabChoose,
				},
			);

		} else {

			handleReloadData(
				{
					page,
					limit: 5,
					// next_id: tempReview.newsReview.next_id,
					type_review: tabChoose,
				},
			);

		}

		// setLoadmore((data) => ({ ...data, limit }));
		setTempReview((data) => ({
			...data,
			newsReview: {
				...data.newsReview,
				current: page,
				on_load: true,
			},
		}));

	};

	const handleFollow = (id) => {

		const temp = [...topMembers];

		const tempIdx = temp.findIndex(
			(item) => item.rvwr_user_id === id,
		);
		const tempData = temp[tempIdx];

		if (!tempData.is_follow) {

			tempData.is_follow = !tempData.is_follow;

		} else {

			tempData.is_follow = false;

		}

		if (!storeData.storeSelf.data.id) {

			handleLogIn();

		} else {

			setTopMembers(temp);

			submitFollow({
				data: {
					user_id: storeData.storeSelf.data.id,
					follow_user_id: id,
				},
				Authorization: Cookies.get("token"),
			}).then((res) => {

				if (res.data.meta.code === 200) {

					console.log(res.data.meta.msg);

				}

			}).catch((err) => console.log(err));

		}

	};

	const onClickDataLayer = (name, placement) => {

		const data = {
			event: "click_banner",
			username: storeData.storeSelf?.data?.username || "guest",
			is_login: !!storeData.storeSelf?.data?.username,
			bannername: name,
			placement,
		};

		setDataLayer(data, "GTM");

	};

	const handleBannerView = (placement) => {

		// eslint-disable-next-line max-len
		const filteredDataBanner = Array.isArray(DataBanner) ? DataBanner.filter((banner) => banner.placement === placement) : [];
		if (filteredDataBanner.length > 0 && !bannerFlags[placement]) {

			setDataLayer({
				event: "view_banner",
				username: storeData.storeSelf?.data?.username || "guest",
				is_login: !!storeData.storeSelf?.data?.username,
				bannername: filteredDataBanner[0].name,
				placement,
			}, "GTM");

			setBannerFlags((prevFlags) => ({
				...prevFlags,
				[placement]: true,
			}));

		}

	};

	const statusCompleting = () => {

		let completing;

		const dataComplete = storeData.storeCompleting?.data?.data;
		const profileData = Array.isArray(dataComplete?.step) ? dataComplete.step : [];

		if (process.env.NEXT_PUBLIC_ALLO_STATUS === "ON") {

			completing = {
				personalInfo: profileData?.filter((complete) => complete.step === "complete_personal_info" && complete.status === true).length > 0,
				beautyProfile: profileData?.filter((complete) => complete.step === "complete_skin_profile" && complete.status === true).length > 0 && profileData?.filter((complete) => complete.step === "complete_hair_profile" && complete.status === true).length > 0,
				beautyConcern: profileData?.filter((complete) => complete.step === "complete_beauty_concern" && complete.status === true).length > 0,
				verifyEmail: dataComplete?.account_status?.filter((complete) => complete.description === "complete_account_allo" && complete.status === true).length > 0,
			};

		} else {

			completing = {
				personalInfo: profileData?.filter((complete) => complete.step === "complete_personal_info" && complete.status === true).length > 0,
				beautyProfile: profileData?.filter((complete) => complete.step === "complete_skin_profile" && complete.status === true).length > 0 && profileData?.filter((complete) => complete.step === "complete_hair_profile" && complete.status === true).length > 0,
				beautyConcern: profileData?.filter((complete) => complete.step === "complete_beauty_concern" && complete.status === true).length > 0,
				verifyEmail: profileData?.filter((complete) => complete.step === "complete_verify_email" && complete.status === true).length > 0,
			};

		}

		return completing;

	};

	useEffect(() => {

		if (isVisibleBannerBottom) {

			handleBannerView("FDBR_home_web_bottom");

		}

		if (isVisibleBannerTop) {

			handleBannerView("FDBR_home_web_top");

		}

	}, [isVisibleBannerBottom, isVisibleBannerTop]);

	useEffect(() => {

		if (storeData.storeReview.data && storeData.storeReview.data.length > 0) {

			if (tempReview.newsReview.on_load) {

				setTempReview((data) => ({
					...data,
					newsReview: {
						...data.newsReview,
						data:	[...data.newsReview.data, ...storeData.storeReview.data],
						current: storeData.storeReview.paging.page,
						total: storeData.storeReview.paging.total,
						next_id: storeData.storeReview.paging.next_id,
						on_load: false,
					},
				}));

			} else {

				setTempReview((data) => ({
					...data,
					newsReview: {
						...data.newsReview,
						data:	storeData.storeReview.data,
						current: storeData.storeReview.paging.page,
						total: storeData.storeReview.paging.total,
						next_id: storeData.storeReview.paging.next_id,
						on_load: false,
					},
				}));

			}

		} else {

			setTempReview((data) => ({ ...data }));

		}

	}, [storeData.storeReview.data]);

	useEffect(() => {

		if (Array.isArray(storeData?.storeHighlightReview?.reviews)) {

			const dataHighlight = storeData.storeHighlightReview?.reviews?.map((item) => ({
				...item,
				is_expand: false,
			}));

			setTempReview((data) => ({ ...data, highlightReview: dataHighlight }));

		}

	}, [storeData.storeHighlightReview]);

	useEffect(() => {

		if (typeof storeData?.storeTopMembers?.data === "object") {

			setTopMembers((data) => [...data, ...storeData.storeTopMembers.data]);

		}

	}, [storeData.storeTopMembers.data]);

	useEffect(() => {

		// handleTablist();
		handleBanner("FDBR_home_web_top");
		handleBanner("FDBR_home_web_bottom");

		// dispatch(
		// 	loadCategory({}),
		// );

		dispatch(
			loadBrandList({}),
		);

		dispatch(
			loadTopMembers({
				Authorization: Cookies.get("token") || "",
			}),
		);

		setDataLayer({
			event: "view_fdbr_homepage",
			username: storeData.storeSelf?.data?.username || "guest",
			is_login: !!storeData.storeSelf?.data?.username,
			device: prop.isMobile ? "mobile" : "desktop",
			referral: prop.query?.ref ? prop.query?.ref : prop.referer,
		}, "GTM");

	}, []);

	useEffect(() => {

		const statusComplete = statusCompleting();

		if (Cookies.get("token") && statusComplete.beautyConcern && statusComplete.beautyProfile) {

			dispatch(
				loadProductMatches({
					Authorization: Cookies.get("token") || "",
					limit: 5,
				}),
			);

		}

	}, [storeData.storeCompleting?.data?.data]);

	const setDataLayerProductMatches = (target) => {

		const data = {
			username: prop.getStoreSelf?.data?.username,
			is_login: !!prop.getStoreSelf?.data?.username,
			device: prop.isMobile ? "mobile" : "desktop",
		};

		if (target === "product-detail") {

			setDataLayer().clickProductDetail({
				...data,
			});

		} else if (target === "brand-detail") {

			setDataLayer().clickBrandDetail({
				...data,
			});

		}

	};

	return (
		<Layout
			home
			ismobile={prop.isMobile}
			adsHead={prop.adsHead}
			adsFoot={prop.adsFoot}
			pageType="Front Page"
			id="card-top"
		>
			<MetaHead />
			{
				prop.isMobile
					? (
						<Banner
							component_id="banner-1-mobile"
							placeholder="staticbanner1"
							name="staticbanner1"
							is_mobile
							class_name="banner-1-mobile"
						/>
					)
					: (
						<Banner
							component_id="id_big_adds_reviews"
							name="billboard"
							placeholder="billboard"
							is_mobile={prop.isMobile}
							class_name="billboard-home"
						/>
					)
			}

			<div className="top-container">

				{
					(props.getHighlightReview?.reviews ?? []).length
						? (
							<HighlightReview
								isMobile={prop.isMobile}
								highlightReview={prop.getHighlightReview}
								reviews={tempReview.highlightReview.reviews}
								self={prop.getStoreSelf}
								user={prop.getStoreSelf}
								handleExpandText={handleExpandTextHighlight}
								DataBanner={Array.isArray(DataBanner) ? DataBanner.filter((data) => data.placement === "FDBR_home_web_top") : []}
								handleAddReview={handleAddReview}
								// imageview
								handleImageView={handleImageView}
								// datalayer
								onClickDataLayer={onClickDataLayer}
								containerRef={refBannerTop}
							/>
						)
						:	null
				}

				{
					storeData.storeProductMatches.is_loading
						?? (
							<SkeletonProductMatches
								isMobile={prop.isMobile}
							/>
						)
				}
				{ storeData.storeProductMatches.data
						&& !storeData.storeProductMatches.error
					? (
						<ProductMatches
							isMobile={prop.isMobile}
							productMatches={storeData.storeProductMatches?.data}
							self={prop.getStoreSelf}
							user={prop.getStoreSelf}
							handleAddReview={handleAddReview}
							onClickProductDetail={() => setDataLayerProductMatches("product-detail")}
							onClickBrandDetail={() => setDataLayerProductMatches("brand-detail")}
						/>
					) : (
						<ErrProductMatches
							isMobile={prop.isMobile}
						/>
					)}

			</div>

			<FakeFree isMobile={prop.isMobile} />

			<div className="main-container">

				<NewestReview
					isMobile={prop.isMobile}
					self={prop.getStoreSelf}
					user={prop.getStoreSelf}
					newestReviews={tempReview?.newsReview}
					// newestReviews={prop.getNewestReviewData}
					open_login={handleLogIn}
					handle_like={handleLike}
					// pagination={pagination}
					handleExpandText={handleExpandText}
					// handlePagination={handlePagination}
					goToEditReview={handleGoToEditReview}
					toggle_comment={handleToggleComment}
					// load_comments={loadComments}
					handle_input={handleInput}
					handle_comment={handleComment}
					handleOpenReport={handleOpenReport}
					// imageview
					handleImageView={handleImageView}
					// handlink newest
					tabChoose={tabChoose}
					tabList={props?.tabList}
					handleChangeTabs={handleChangeTabs}
					handleLoadMore={handleLoadMore}
				/>

				{
					storeData.storeTopMembers.is_loading
						? (
							<SkeletonTopMember
								isMobile={prop.isMobile}
							/>
						)
						: null
				}

				{
					storeData.storeTopMembers.data?.length > 0
						? (
							<TopMember
								isMobile={prop.isMobile}
								data={topMembers}
								DataBanner={Array.isArray(DataBanner) ? DataBanner.filter((data) => data.placement === "FDBR_home_web_bottom") : []}
								handleFollow={handleFollow}
								// datalayer
								onClickDataLayer={onClickDataLayer}
								containerRef={refBannerBottom}
							/>
						) : null
				}

				{
					storeData.storeTopMembers.error
						? (
							<ErrTopMember
								isMobile={prop.isMobile}
								DataBanner={Array.isArray(DataBanner) ? DataBanner.filter((data) => data.placement === "FDBR_home_web_bottom") : []}
							/>
						)
						: null
				}

			</div>

			<InfoFooter
				isMobile={prop.isMobile}
				DataBanner={Array.isArray(DataBanner) ? DataBanner.filter((data) => data.placement === "FDBR_home_web_bottom") : []}
				// datalayer
				onClickDataLayer={onClickDataLayer}
				containerRef={refBannerBottom}
			/>

			<style jsx>
				{`
				.banner-area {
					height: 60px;
				}

				.top-container {
					background: ${prop.isMobile ? "none" : "linear-gradient(180deg, #FFFFFF 3.12%, #FBE9ED 65%)"};
					padding-bottom: ${prop.isMobile ? 0 : "32px"};
				}

				.main-container {
					display: flex;
					width: 100%;
					max-width: ${prop.isMobile ? "100%" : "1280px"};
					margin: 0 auto;
					flex-direction: ${prop.isMobile ? "column-reverse" : null};

					gap: ${prop.isMobile ? "32px" : "60px"};
				}
				`}
			</style>
			{
				IsModalReport
					&& (
						<ModalReport
							onClose={() => setIsModalReport(false)}
							handleSubmitReport={handleSubmitReport}
							isMobile={prop.isMobile}
						/>
					)
			}

			<ImageReviews
				isMobile={prop.isMobile}
				isOpen={imagePopup.isOpen}
				imgs={imagePopup.imgs}
				currImg={imagePopup.currImg}
				setCurrImg={(data) => setImagePopup((state) => ({ ...state, currImg: data }))}
				onClose={() => setImagePopup((state) => ({ ...state, isOpen: false }))}
			/>

		</Layout>
	);

};

export const getServerSideProps = wrapper.getServerSideProps(
	async ({
		store, req, res, query,
	}) => {

		let userAgent;
		let cookies;
		let authorization = null;

		if (req) {

			// if you are on the server and you get a "req" property from your context
			userAgent = req.headers["user-agent"]; // get the user-agent from the headers

		} else {

			// if you are on the client you can access the navigator from the window object
			userAgent = navigator.userAgent;

		}

		// eslint-disable-next-line no-nested-ternary
		const isMobile = userAgent && checkDevice(userAgent);

		const isServer = !!req;

		if (req.headers.cookie) {

			cookies = cookie.parse(req.headers.cookie);
			authorization = cookies.token;

		}

		await store.dispatch(
			loadSelf({
				payload: {
					api_env: process.env.NEXT_PUBLIC_NODE_ENV,
					env: Env.HEADERS,
					Authorization: authorization,
					is_server: isServer,
					is_allo: process.env.NEXT_PUBLIC_ALLO_STATUS === "ON",
				},
			}),
		);

		await store.dispatch(
			loadHighlightReview({
				// Authorization: authorization,
			}),
		);

		// get tab list first, for determine reviews type to be shown first
		let tabList = [];
		await fetch(
			`${process.env.NEXT_PUBLIC_ROOT_DOMAIN}/api-new/getTabList`,
			{ headers: Env.HEADERS },
		)
			.then(async (resFetchList) => {
				const resFetch = await resFetchList.json();
				if (resFetch?.meta?.code >= 200 && resFetch?.meta?.code < 300) {
					tabList = resFetch?.data;
				}
			})
			.catch(() => {
				tabList = vars.Tabs_news;
			})
			.finally(async () => {
				// first index of tab list determines what tab will be shown first
				// after tab list fetch, then continue to fetch reviews data based
				const activeTab = tabList[0];
				await store.dispatch(
					loadReview({
						Authorization: Cookies.get("token") || "",
						page: 1,
						limit: 10,
						next_id: 0,
						type_review: activeTab?.type,
					}),
				);

			});

		store.dispatch(END);
		await store.sagaTask.toPromise();

		const site = isMobile === "iPhone" || isMobile === "Android" ? "mobile" : "desktop";
		const getStoreSelf = !!store.getState().storeSelf.data === true
			? store.getState().storeSelf
			: [];

		if (store.getState().storeSelf?.status === "fetch_error") {

			checkSelfCookie(res, true);

		}

		const getHighlightReview = store.getState().storeHighlightReview?.data || [];
		const getNewestReviewData = store.getState().storeReview;

		const	adsHead = await AdsDetik(site, "taghead");
		const	adsFoot = await AdsDetik(site, "tagfoot");

		const referer = req.headers?.referer || "";

		return {
			props: {
				query,
				isMobile,
				getStoreSelf,
				getHighlightReview,
				adsHead,
				adsFoot,
				referer,
				tabList,
				getNewestReviewData,
			}, // will be passed to the page component as props
		};

	},
);

export default Index;
